// extracted by mini-css-extract-plugin
export default {"header":"ProductVariantInventoryForm_header__PayKf","iconDelete":"ProductVariantInventoryForm_iconDelete__qrKjP","iconEdit":"ProductVariantInventoryForm_iconEdit__8g4A2"};